import CancelIcon from '@mui/icons-material/Cancel'
import { Step, StepLabel, Stepper } from '@mui/material'
import moment from 'moment'
import { PendingStatus } from '@components'
import { getActiveSubmissionStep } from '@submissions/submissions/utils'
import * as css from './styles'
import { Phase, PhaseStep } from '../../config'

interface Props {
  submission: Record<string, any>
  steps: PhaseStep[]
  progressMap: Record<
    Phase,
    {
      step: number
      progress: number
    }
  >
  creativeClassificationEnabled?: boolean
}

export const SubmissionStatusStepper = ({
  submission,
  steps,
  progressMap,
  creativeClassificationEnabled = false,
}: Props) => {
  const activeStep = getActiveSubmissionStep({
    phase: submission.phase,
    progressMap,
    creativeClassificationEnabled,
  })

  return (
    <css.StepperContainer>
      <Stepper
        css={css.stepper}
        activeStep={activeStep}
        connector={<css.CustomStepConnector />}
        alternativeLabel
      >
        {steps.map(({ label, phase }) => {
          const isPaused = label === PendingStatus.REJECTED
          const timestamp = getPhaseTimestamp({ phase, sub: submission })
          const hasErrors = Boolean(
            submission?.errors?.filter(error => error.error_phase === phase).length,
          )

          const getCustomStepIcon = isPaused ? () => <CancelIcon color="error" /> : undefined

          return (
            <Step key={label}>
              <StepLabel error={hasErrors} StepIconComponent={getCustomStepIcon}>
                <div>{label}</div>
                <css.Timestamp>{timestamp}</css.Timestamp>
              </StepLabel>
            </Step>
          )
        })}
      </Stepper>
    </css.StepperContainer>
  )
}

function getPhaseTimestamp({ phase, sub }) {
  let timestampKey = ''
  if (phase === Phase.GENERATING_CLASSIFICATION) {
    timestampKey = `${Phase.GENERATING_STATICS.toLowerCase()}_at`
  } else {
    timestampKey = `${phase.toLowerCase()}_at`
  }

  const timestamp = sub[timestampKey]

  if (!timestamp) return null

  return moment(timestamp).format('h:mm:ss a')
}
